/**
 * A no-operation function that does nothing.
 * This can be used as a placeholder or default function.
 *
 * @example
 * noop(); // Does nothing
 *
 * @returns {void} This function does not return anything.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function noop(..._: any[]): void {}
